import router from '@/router'

router.beforeEach((to, from, next) => {
	document.title = (to.meta.menuName || to.name) + ' - 北京市大兴区数字文化馆';
	if(to.name === 'login' && (from.name === 'register' || from.name === 'reset') && !to.query.replace){
		return  next({
			path: '/login',
			replace: true,
			query: {
				replace: true
			}
		})
	}else if(to.name === 'login' && from.name && !(to.query.lastName || to.query.replace)){
		return next({
			path: '/login',
			replace: true,
			query: {
				lastName: from.path,
				lastParams: JSON.stringify(from.query || {})
			}
		})
	}
	next();
})
